export const MAPPER = window?._env_ || null;
export const URLMAPPER = MAPPER?.domains || null;
export const APPMODE =
  Array.isArray(URLMAPPER) && URLMAPPER[window.location.host]?.appMode
    ? URLMAPPER[window.location.host]?.appMode
    : MAPPER?.appMode || process.env.REACT_APP_ENV;
